// @flow

import type { Action } from './store.type';

export const UPDATE_FIELD = 'UPDATE_FIELD';
type UPDATE_FIELD_TYPE = 'UPDATE_FIELD';
type UpdateFieldAction = Action<UPDATE_FIELD_TYPE, any>;

export const UPDATE_MULTI_FIELDS = 'UPDATE_MULTI_FIELDS';
type UPDATE_MULTI_FIELDS_TYPE = 'UPDATE_MULTI_FIELDS';
type UpdateMultiFieldsAction = Action<UPDATE_MULTI_FIELDS_TYPE, any>;

export const CHANGE_ACTIVE_MENU_ITEM = 'CHANGE_ACTIVE_MENU_ITEM';
type CHANGE_ACTIVE_MENU_ITEM_TYPE = 'CHANGE_ACTIVE_MENU_ITEM';
type ChangeActiveMenuItemAction = Action<CHANGE_ACTIVE_MENU_ITEM_TYPE, string>;

export const CHANGE_SELECTED_PAGE = 'CHANGE_SELECTED_PAGE';
type CHANGE_SELECTED_PAGE_TYPE = 'CHANGE_SELECTED_PAGE';
type ChangeSelectedPageAction = Action<CHANGE_SELECTED_PAGE_TYPE, any>;

export const UPDATE_MENU_SETTING = 'UPDATE_MENU_SETTING';
type UPDATE_MENU_SETTING_TYPE = 'UPDATE_MENU_SETTING';
type UpdateMenuSettingAction = Action<UPDATE_MENU_SETTING_TYPE, any>;

export const UPDATE_WHOLE_MENU_SETTING = 'UPDATE_WHOLE_MENU_SETTING';
type UPDATE_WHOLE_MENU_SETTING_TYPE = 'UPDATE_WHOLE_MENU_SETTING';
type UpdateWholeMenuSettingAction = Action<UPDATE_WHOLE_MENU_SETTING_TYPE, any>;

export const REMOVE_ELEMENT = 'REMOVE_ELEMENT';
type REMOVE_ELEMENT_TYPE = 'REMOVE_ELEMENT';
type RemoveElementAction = Action<REMOVE_ELEMENT_TYPE, any>;

export const TOGGLE_HIDE_MENU_ITEM = 'TOGGLE_HIDE_MENU_ITEM';
type TOGGLE_HIDE_MENU_ITEM_TYPE = 'TOGGLE_HIDE_MENU_ITEM';
type ToggleHideMenuItemAction = Action<
  TOGGLE_HIDE_MENU_ITEM_TYPE,
  { id: string, updateType: string }
>;

export const UPDATE_THEME_SETTING = 'UPDATE_THEME_SETTING';
type UPDATE_THEME_SETTING_TYPE = 'UPDATE_THEME_SETTING';
type UpdateThemeSettingAction = Action<UPDATE_THEME_SETTING_TYPE, any>;

// Get theme setting by id
export const GET_THEME_SETTING_BY_ID_REQUEST = 'GET_THEME_SETTING_BY_ID_REQUEST';
type GET_THEME_SETTING_BY_ID_REQUEST_TYPE = 'GET_THEME_SETTING_BY_ID_REQUEST';

export const GET_THEME_SETTING_BY_ID_SUCCESS = 'GET_THEME_SETTING_BY_ID_SUCCESS';
type GET_THEME_SETTING_BY_ID_SUCCESS_TYPE = 'GET_THEME_SETTING_BY_ID_SUCCESS';

export const GET_THEME_SETTING_BY_ID_FAILURE = 'GET_THEME_SETTING_BY_ID_FAILURE';
type GET_THEME_SETTING_BY_ID_FAILURE_TYPE = 'GET_THEME_SETTING_BY_ID_FAILURE';

type GetThemeSettingByIdRequestAction = Action<GET_THEME_SETTING_BY_ID_REQUEST_TYPE, null>;
type GetThemeSettingByIdSuccessAction = Action<GET_THEME_SETTING_BY_ID_SUCCESS_TYPE, any>;
type GetThemeSettingByIdFailureAction = Action<
  GET_THEME_SETTING_BY_ID_FAILURE_TYPE,
  { error: any }
>;

export const TOGGLE_EXPAND_FULLSCREEN = 'TOGGLE_EXPAND_FULLSCREEN';
type TOGGLE_EXPAND_FULLSCREEN_TYPE = 'TOGGLE_EXPAND_FULLSCREEN';
type ToggleFullscreenAction = Action<TOGGLE_EXPAND_FULLSCREEN_TYPE, string>;

// Get theme setting default value by id
export const GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST =
  'GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST';
type GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST_TYPE =
  'GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST';

export const GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS =
  'GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS';
type GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS_TYPE =
  'GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS';

export const GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE =
  'GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE';
type GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE_TYPE =
  'GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE';

type GetThemeSettingDefaultValueByIdRequestAction = Action<
  GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_REQUEST_TYPE,
  null
>;
type GetThemeSettingDefaultValueByIdSuccessAction = Action<
  GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_SUCCESS_TYPE,
  any
>;
type GetThemeSettingDefaultValueByIdFailureAction = Action<
  GET_THEME_SETTING_DEFAULT_VALUE_BY_ID_FAILURE_TYPE,
  { error: any }
>;

// Edit theme setting by id
export const EDIT_THEME_SETTING_BY_ID_REQUEST = 'EDIT_THEME_SETTING_BY_ID_REQUEST';
type EDIT_THEME_SETTING_BY_ID_REQUEST_TYPE = 'EDIT_THEME_SETTING_BY_ID_REQUEST';

export const EDIT_THEME_SETTING_BY_ID_SUCCESS = 'EDIT_THEME_SETTING_BY_ID_SUCCESS';
type EDIT_THEME_SETTING_BY_ID_SUCCESS_TYPE = 'EDIT_THEME_SETTING_BY_ID_SUCCESS';

export const EDIT_THEME_SETTING_BY_ID_FAILURE = 'EDIT_THEME_SETTING_BY_ID_FAILURE';
type EDIT_THEME_SETTING_BY_ID_FAILURE_TYPE = 'EDIT_THEME_SETTING_BY_ID_FAILURE';

type EditThemeSettingByIdRequestAction = Action<EDIT_THEME_SETTING_BY_ID_REQUEST_TYPE, null>;
type EditThemeSettingByIdSuccessAction = Action<EDIT_THEME_SETTING_BY_ID_SUCCESS_TYPE, any>;
type EditThemeSettingByIdFailureAction = Action<
  EDIT_THEME_SETTING_BY_ID_FAILURE_TYPE,
  { error: any }
>;
export const CHANGE_DEVICE = 'CHANGE_DEVICE';
type CHANGE_DEVICE_TYPE = 'CHANGE_DEVICE_ACTION_TYPE';
type ChangeDeviceAction = Action<CHANGE_DEVICE_TYPE, number>;

// Get theme setting of cloned source theme by id
export const GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST =
  'GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST';
type GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_TYPE =
  'GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST';

export const GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_SUCCESS =
  'GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_SUCCESS';
type GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_SUCCESS_TYPE =
  'GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_SUCCESS';

export const GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_FAILURE =
  'GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_FAILURE';
type GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_FAILURE_TYPE =
  'GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_FAILURE';

type GetClonedSourceThemeSettingByIdRequestAction = Action<
  GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_TYPE,
  null
>;
type GetClonedSourceThemeSettingByIdSuccessAction = Action<
  GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_SUCCESS_TYPE,
  any
>;
type GetClonedSourceThemeSettingByIdFailureAction = Action<
  GET_CLONED_SOURCE_THEME_SETTING_BY_ID_REQUEST_FAILURE_TYPE,
  { error: any }
>;

// Get list theme default value
export const GET_LIST_THEME_DEFAULT_VALUE = 'GET_LIST_THEME_DEFAULT_VALUE_REQUEST';
type GET_LIST_THEME_DEFAULT_VALUE_REQUEST_TYPE = 'GET_LIST_THEME_DEFAULT_VALUE_REQUEST';

export const GET_LIST_THEME_DEFAULT_VALUE_SUCCESS = 'GET_LIST_THEME_DEFAULT_VALUE_SUCCESS';
type GET_LIST_THEME_DEFAULT_VALUE_SUCCESS_TYPE = 'GET_LIST_THEME_DEFAULT_VALUE_SUCCESS';

export const GET_LIST_THEME_DEFAULT_VALUE_FAILURE = 'GET_LIST_THEME_DEFAULT_VALUE_FAILURE';
type GET_LIST_THEME_DEFAULT_VALUE_FAILURE_TYPE = 'GET_LIST_THEME_DEFAULT_VALUE_FAILURE';

type GetListThemeDefaultValueRequestAction = Action<
  GET_LIST_THEME_DEFAULT_VALUE_REQUEST_TYPE,
  null
>;
type GetListThemeDefaultValueSuccessAction = Action<GET_LIST_THEME_DEFAULT_VALUE_SUCCESS_TYPE, any>;
type GetListThemeDefaultValueFailureAction = Action<
  GET_LIST_THEME_DEFAULT_VALUE_FAILURE_TYPE,
  { error: any }
>;

// Get theme setting by name
export const GET_THEME_SETTING_BY_NAME = 'GET_THEME_SETTING_BY_NAME_REQUEST';
type GET_THEME_SETTING_BY_NAME_REQUEST_TYPE = 'GET_THEME_SETTING_BY_NAME_REQUEST';

export const GET_THEME_SETTING_BY_NAME_SUCCESS = 'GET_THEME_SETTING_BY_NAME_SUCCESS';
type GET_THEME_SETTING_BY_NAME_SUCCESS_TYPE = 'GET_THEME_SETTING_BY_NAME_SUCCESS';

export const GET_THEME_SETTING_BY_NAME_FAILURE = 'GET_THEME_SETTING_BY_NAME_FAILURE';
type GET_THEME_SETTING_BY_NAME_FAILURE_TYPE = 'GET_THEME_SETTING_BY_NAME_FAILURE';

type GetThemeSettingByNameRequestAction = Action<GET_THEME_SETTING_BY_NAME_REQUEST_TYPE, null>;
type GetThemeSettingByNameSuccessAction = Action<GET_THEME_SETTING_BY_NAME_SUCCESS_TYPE, any>;
type GetThemeSettingByNameFailureAction = Action<
  GET_THEME_SETTING_BY_NAME_FAILURE_TYPE,
  { error: any }
>;

export type ThemeSettingAction =
  | UpdateMultiFieldsAction
  | UpdateFieldAction
  | ChangeActiveMenuItemAction
  | ChangeSelectedPageAction
  | UpdateMenuSettingAction
  | RemoveElementAction
  | ToggleHideMenuItemAction
  | UpdateWholeMenuSettingAction
  | ToggleFullscreenAction
  | GetThemeSettingByIdRequestAction
  | GetThemeSettingByIdSuccessAction
  | GetThemeSettingByIdFailureAction
  | GetThemeSettingDefaultValueByIdRequestAction
  | GetThemeSettingDefaultValueByIdSuccessAction
  | GetThemeSettingDefaultValueByIdFailureAction
  | UpdateThemeSettingAction
  | EditThemeSettingByIdRequestAction
  | EditThemeSettingByIdSuccessAction
  | EditThemeSettingByIdFailureAction
  | ChangeDeviceAction
  | GetClonedSourceThemeSettingByIdRequestAction
  | GetClonedSourceThemeSettingByIdSuccessAction
  | GetClonedSourceThemeSettingByIdFailureAction
  | GetListThemeDefaultValueRequestAction
  | GetListThemeDefaultValueSuccessAction
  | GetListThemeDefaultValueFailureAction
  | GetThemeSettingByNameRequestAction
  | GetThemeSettingByNameSuccessAction
  | GetThemeSettingByNameFailureAction;

export type ThemeSettingState = {
  activeMenuItem: string,
  activeMenuItemDetail: any,
  selectedPage: { label: string, value: string },
  collectionSetting: any,
  searchSetting: any,
  commonSetting: any,
  updateType: string,
  device: number,
  listThemeTemplate: any[]
};
